import { extendTheme } from '@chakra-ui/react';

const customTheme = {
  styles: {
    global: ({ colorMode }) => ({
      body: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '14px',
        letterSpacing: '-0.2px',
        lineHeight: '24px',
        color: 'gray.900',
        bg: colorMode === 'dark' ? 'gray.800' : 'gray.50',
      },
      _focus: {
        boxShadow: 'none !important',
      },
      _focusVisible: {
        // boxShadow: '0 0 0 3px #00A5C8 !important',
        boxShadow: 'none !important',
      },
    }),
  },
  colors: {
    blue: {
      100: '#EBF8FB',
      200: '#F1F6FF',
      400: '#5CCAE1',
      500: '#337bff',
      600: '#365CBA',
    },
    orange: {
      100: '#FFEFE4',
      200: '#FECAA4',
      400: '#FFA35E',
      500: '#FF6D00',
      600: '#C55400',
    },
    gray: {
      50: '#F4F8F9',
      100: '#EBEBEB',
      200: '#D0D0D0',
      300: '#C2C7CC',
      400: '#A7B3BF',
      500: '#9BA7B3',
      600: '#858F99',
      700: '#6F7780',
      800: '#525C66',
      900: '#3B4B53',
    },
    white: {
      0: '#FFFFFF',
    },
    black: {
      900: '#202323',
    },
    green: {
      100: '#EAF2DF',
      200: '#D7E9BE',
      400: '#B7D58E',
      500: '#20BF55',
      600: '#64A707',
      700: '#2DCE62',
      800: '#38A75D',
    },
    yellow: {
      50: '#FFF9E9',
      100: '#FFF0C4',
      200: '#FFE494',
      400: '#FBD35E',
      500: '#FAC62E',
      600: '#D59E00',
    },
    red: {
      100: '#FFDEDC',
      200: '#FF9C96',
      400: '#FF6359',
      500: '#FF382C',
      600: '#BF0F05',
    },
  },
  fonts: {
    body: 'Inter, sans-serif',
    heading: 'k2d, sans-serif',
  },
  fontSizes: {},
  fontWeights: {},
  lineHeights: {},
  letterSpacings: {},
  breakpoints: {
    sm: '320px',
    md: '640px',
    lg: '960px',
    xl: '1366px',
    '2xl': '1920px',
  },
  components: {
    Button: {
      baseStyle: {
        letterSpacing: '1px',
        borderRadius: '100px',
      },
      sizes: {
        lg: {
          fontSize: '16px',
          h: '58px',
          px: '26px',
        },
        md: {
          h: '48px',
          px: '22px',
        },
      },
      variants: {
        outline: {
          borderWidth: '2px',
        },
      },
    },
  },
};

const theme = extendTheme(customTheme);

export default theme;
